import cn from 'classnames'
import React, { ReactNode } from 'react'

import { Typography } from '../typography'
import { TOP_TITLE_BAR_HEIGHT } from './constants'
import styles from './TopTitleBar.module.css'

export interface TopTitleBarRootProps extends React.HTMLAttributes<HTMLDivElement> {}

function Root({
  children,
  className,
  style,
  ...rest
}: React.PropsWithChildren<TopTitleBarRootProps>) {
  let left: ReactNode = null
  let titleLabel = ''
  let right: ReactNode = null

  React.Children.forEach(children, (child) => {
    if (!React.isValidElement<{ children?: ReactNode, title?: string }>(child))
      return

    if (child.type === LeftArea)
      left = child.props.children
    if (child.type === CenterArea)
      titleLabel = child.props.title ?? ''
    if (child.type === RightArea)
      right = child.props.children
  })

  const mergedStyle: React.CSSProperties = {
    minHeight: TOP_TITLE_BAR_HEIGHT,
    height: TOP_TITLE_BAR_HEIGHT,
    ...style,
  }

  return (
    <div {...rest} className={cn(styles.wrapper, className)} style={mergedStyle}>
      <LeftArea>{left}</LeftArea>
      <CenterArea title={titleLabel} />
      <RightArea>{right}</RightArea>
    </div>
  )
}

function LeftArea({ children, className }: { children: ReactNode, className?: string }) {
  return <div className={cn(styles.leftArea, className)}>{children}</div>
}

function CenterArea({ title, className }: { title?: string, className?: string }) {
  return (
    <div className={styles.centerArea}>
      {title && (
        <Typography className={cn(styles.title, className)} variant="body-m-bold-tight">
          {title}
        </Typography>
      )}
    </div>
  )
}

function RightArea({ children, className }: { children: ReactNode, className?: string }) {
  return (
    <div className={cn(styles.rightArea, className)}>
      {children}
    </div>
  )
}

export const TopTitleBar = {
  Root,
  LeftArea,
  CenterArea,
  RightArea,
}
